<template lang="pug">
    v-row(align='center' justify="center" v-if="validIncomingPhoneNumber")

        v-snackbar(
            v-model='snackbar.show'
            :color='snackbar.color'
            :timeout="snackbar.timeout"
            top
        )
            | {{ snackbar.text }}
            v-btn(dark text @click='snackbar.show = false')
                | Close

        v-snackbar(
            v-model="complianceSnackbarShow"
            color="warning"
            :timeout="10000"
            top
            multi-line
        )
            div.d-flex.flex-column.align-center
                ul.mb-0.pl-4.text-left
                    li(v-for="warning in complianceWarnings" :key="warning") {{ warning }}
                v-btn(dark text @click="complianceSnackbarShow = false")
                    | Dismiss

        DialPad(
            v-if="dialPadDialog"
            :call-id="callId"
            :close-dial-pad="closeDialPad"
            :send-digit="sendDigit"
        )

        InstantVoicemailDialog(
            v-if="instantVoicemailDialog"
            :call="call"
            :close-instant-voicemail="closeInstantVoicemail"
        )

        TransferDialog(
            v-if="transferDialog"
            :call-id="callId"
            communication-provider="telnyx"
            :complete-attempt-for-internal-transfer="completeAttemptForInternalTransfer"
            :destination="transferDestination"
            :destination-id="transferDestinationID"
            :end-call="endCall"
            :exit-transfer-dialog="exitTransferDialog"
            :is-muted="isMuted"
            :location="transferLocation"
            :mute-unmute-call="muteUnmuteCall"
            :mute-btn-color="muteBtnColor"
            :on-hold="onHold"
            :toggle-on-hold="toggleOnHold"
            :toggle-is-muted="toggleIsMuted"
            :send-digit="sendDigit"
            :show-snackbar="showSnackbar"
            :transfer-to-extension="transferToExtension"
            :transfer-to-number="transferToNumber"
            :type="transferType"
            :voice-mail-recording="voiceMailRecording"
        )

        audio#remoteMedia(
            autoplay="true"
        )

        v-col.text-center.padding-xs(v-if="renderStartActions")
            ManualMode(
                v-if="renderManualMode"
                :enter-manual-mode="enterManualMode"
                :exit-manual-mode="exitManualMode"
                :has-logged-in-queues="hasLoggedInQueues"
                :is-manual-mode="isManualMode"
                :organization-users="organizationUsers"
                :render-enroll-as-eligible="true"
                :valid-campaign-customer-active-id="validCurrentCampaignCustomer"            
            )

            v-btn-toggle.my-1
                v-btn(
                    @click="startNextDial();"
                    color='success'
                    :disabled='isStartNextDialButtonDisabled'
                    :loading='initializingPhoneCall'
                    small
                )
                    | Start Next Dial

                v-menu(
                    v-if="validAvailableDialPhoneNumbers"
                    bottom
                    close-on-click
                    transition='scale-transition'
                    :disabled='isStartNextDialButtonDisabled || initializingPhoneCall || !validAvailableDialPhoneNumbers'
                )
                    template(v-slot:activator='{ on, attrs }')
                        v-btn(
                            light
                            small
                            v-bind='attrs'
                            v-on='on'
                        )
                            v-icon(v-if="validAvailableDialPhoneNumbers") mdi-menu-down
                            v-icon(v-else) mdi-minus
                    v-list

                        v-list-item(
                            v-for='(pn, idx) in availableDialPhoneNumbers'
                            :key='idx'
                            ripple
                            :disabled="!phoneAllowed(pn)"
                            @click='startNextDial(pn.customer_phone_number_id);'
                        )
                            v-list-item-icon
                                v-icon(v-if="!phoneAllowed(pn)" color="error") mdi-alert
                                v-icon(v-if="nextAttemptableID === pn.customer_phone_number_id") mdi-chevron-right
                            v-list-item-content
                                v-list-item-title {{ pn.phone_number_phone_number | tel }}
                                v-list-item-subtitle {{ pn.phone_number_type | titleize }}

        v-col.text-center.padding-xs(v-if="renderPhoneControls && isSupervisorLoading")
            v-row.fill-height(align-content='center' justify='center')
                v-col.text-subtitle-1.text-center(cols='12' style='padding-bottom:0;margin-bottom:0')
                    | Connecting to Conference
                v-col(cols='6')
                    v-progress-linear(color='info' indeterminate='' rounded='' height='6')

        v-col.text-center.padding-xs(v-else-if="renderPhoneControls && !isSupervisorLoading")
            v-simple-table(dense)
                template(v-slot:default)
                    tbody
                        tr
                            td
                                v-btn-toggle(rounded dense background-color="warning")
                                    v-tooltip(bottom)
                                        template(v-slot:activator='{ on, attrs }')
                                            v-btn(v-bind='attrs' v-on='on' @click="muteUnmuteCall();" :color="muteBtnColor" :disabled="onHold")
                                                v-icon(dark) mdi-microphone-off
                                        span(v-if="!isMuted") Mute
                                        span(v-else) Unmute

                                    v-tooltip(bottom)
                                        template(v-slot:activator='{ on, attrs }')
                                            v-btn(:disabled="isSupervisor" v-bind='attrs' v-on='on' @click="holdUnholdCall();" :color="holdBtnColor")
                                                v-icon(dark v-if="!onHold") mdi-pause-octagon
                                                v-icon(dark v-else) mdi-play-circle
                                        span(v-if="!onHold") Place on Hold
                                        span(v-else) Return to Call

                                    v-tooltip(bottom)
                                        template(v-slot:activator='{ on, attrs }')
                                            v-btn(
                                                v-bind='attrs'
                                                v-on='on'
                                                ripple
                                                @click.stop="openDialPad();"
                                            )
                                                v-icon(dark) mdi-dialpad
                                        span Dial Pad

                                    v-tooltip(bottom v-if="instantVoiceMailEnabled")
                                        template(v-slot:activator='{ on, attrs }')
                                            v-btn(v-bind='attrs' v-on='on' @click="openInstantVoicemailDialog();")
                                                v-icon(dark) mdi-voicemail
                                        span Instant Voicemail

                                    v-tooltip(v-if="!isSupervisor" bottom)
                                        template(v-slot:activator='{ on, attrs }')
                                            v-btn(v-bind='attrs' v-on='on' @click="endCall();")
                                                v-icon(dark) mdi-phone-hangup
                                        span End Call

                                    v-tooltip(v-else bottom)
                                        template(v-slot:activator='{ on, attrs }')
                                            v-btn(v-bind='attrs' v-on='on' @click="endCall();")
                                                v-icon(dark) mdi-account-multiple-remove
                                        span(v-if="isBarge") Leave Barge Session
                                        span(v-else-if="isListen") Leave Listen Session
                                        span(v-if="isCoach") Leave Coaching Session

                                    template(v-if="showTransferMenu")
                                        v-menu(
                                            bottom
                                            close-on-click
                                            transition="scale-transition"
                                            offset-y
                                        )
                                            template(v-slot:activator="{ on: menuOn, attrs: menuAttrs }")
                                                v-tooltip(bottom)
                                                    template(v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }")
                                                        v-btn(
                                                            v-bind="{ ...menuAttrs, ...tooltipAttrs }"
                                                            v-on="{ ...menuOn, ...tooltipOn }"
                                                            :disabled="isSupervisor"
                                                        )
                                                            v-icon(dark) mdi-phone-forward
                                                    span Transfer

                                            v-list
                                                template(v-if="allowedInternalBlindTransfersEnabled")
                                                    v-list-item(
                                                        ripple
                                                        @click.stop="openTransferDialog('user', 'internal', 'blind');"
                                                    )
                                                        v-list-item-icon
                                                            v-icon mdi-account-group
                                                        v-list-item-content
                                                            v-list-item-title Blind Transfer
                                                            v-list-item-subtitle Internal
                                                template(v-if="allowedExternalBlindTransfersEnabled")
                                                    v-list-item(
                                                        ripple
                                                        @click.stop="openTransferDialog('unknown', 'external', 'blind');"
                                                    )
                                                        v-list-item-icon
                                                            v-icon mdi-phone-forward
                                                        v-list-item-content
                                                            v-list-item-title Blind Transfer
                                                            v-list-item-subtitle External
                                                template(v-if="allowedExternalWarmTransfersEnabled")
                                                    v-list-item(
                                                        ripple
                                                        @click.stop="openTransferDialog('unknown', 'external', 'warm');"
                                                    )
                                                        v-list-item-icon
                                                            v-icon mdi-phone-forward
                                                        v-list-item-content
                                                            v-list-item-title Warm Transfer
                                                            v-list-item-subtitle External

                            td(v-if="recordEnabled")
                                v-tooltip(bottom)
                                    template(v-slot:activator='{ on, attrs }')
                                        v-btn(
                                            v-bind='attrs'
                                            v-on='on'
                                            @click="pauseResumeRecording();"
                                            :disabled="!validRecordingID"
                                            icon
                                            small
                                            :color="!isRecordingPaused ? 'red' : 'black'"
                                        )
                                            v-icon(dark v-if="!isRecordingPaused") mdi-stop
                                            v-icon(dark v-else) mdi-record-circle
                                    span(v-if="!isRecordingPaused") Pause Call Recording
                                    span(v-else) Resume Call Recording

        v-col.text-center.padding-xs(v-else-if="renderNextActions")
            v-btn.ma-2.btn-margin-xs(
                v-if="renderSaveStopButton"
                color='error'
                :x-small="selectedDispositionHasSmsMessageFollowUp"
                :small="!selectedDispositionHasSmsMessageFollowUp"
                @click="startSaveAndNext(saveAndStopAction);"
                :disabled="!isOkayToSaveAndNext"
            )
                div(v-if="selectedDispositionHasSmsMessageFollowUp")
                    | Save &amp; Send SMS Follow Up
                    v-icon(small) mdi-arrow-right-thick
                    | Stop
                div(v-else)
                    | Save
                    v-icon(small) mdi-arrow-right-thick
                    | Stop

            v-btn.ma-2.btn-margin-xs(
                v-if="renderSaveContinueButton"
                color='success'
                :x-small="selectedDispositionHasSmsMessageFollowUp"
                :small="!selectedDispositionHasSmsMessageFollowUp"
                @click="startSaveAndNext('continue');"
                :disabled="!isOkayToSaveAndNext"
            )
                div(v-if="selectedDispositionHasSmsMessageFollowUp")
                    | Save &amp; Send SMS Follow Up
                    v-icon(small) mdi-arrow-right-thick
                    | Survey
                div(v-else)
                    | Save
                    v-icon(small) mdi-arrow-right-thick
                    | Survey

            v-btn.ma-2.btn-margin-xs(
                v-else
                color='success'
                :x-small="selectedDispositionHasSmsMessageFollowUp"
                :small="!selectedDispositionHasSmsMessageFollowUp"
                @click="startSaveAndNext('continue_and_start');"
                :disabled="!isOkayToSaveAndNext"
            )
                div(v-if="selectedDispositionHasSmsMessageFollowUp")
                    | Save &amp; Send SMS Follow Up
                    v-icon(small) mdi-arrow-right-thick
                    | Dial Next
                div(v-else)
                    | Save
                    v-icon(small) mdi-arrow-right-thick
                    | Dial Next

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState  from "@/store";
    import { TelnyxRTC } from '@telnyx/webrtc';

    // Components
    import DialPad from '@/components/communication_center/phone/dial_pad_dialog.vue';
    import InstantVoicemailDialog from '@/components/communication_center/phone/instant_voicemail_dialog.vue';
    import ManualMode from '@/components/communication_center/shared/manual_mode.vue';
    import TransferDialog from '@/components/communication_center/phone/transfer_dialog.vue';

    // Constants
    import { INBOUND_WRAP_UP, OUTBOUND_WRAP_UP } from '@/constants/agent_statuses';

    // Data
    import { CreateConferenceEvent, CallJoinWebRtcSession,  CreateOutboundCall, CreateDeviceNotificationEvent, HoldCall, UnholdCall, HandleAgentCallDisconnect, CreateWebRtcParticipant, PauseRecording, ResumeRecording, SendDTMF, MuteConferenceLeg, UnMuteConferenceLeg} from "@/data";

    export default Vue.extend({
        data() {
            return {
                agentSoftphone: null,
                agentToken: null,
                availableDialPhoneNumbers: [],
                bus: VolieState.websocketClient().eventBus(),
                call: null,
                componentDestroyed: false,
                conference: null,
                connectedCall: null,
                connection: null,
                device: null,
                dialPadDialog: false,
                complianceWarnings: [],
                complianceSnackbarShow: false,
                complianceSnackbarTimeoutId: null,
                disconnectedCallId: 0,
                disconnectedPhoneCall: false,
                initializingPhoneCall: false,
                instantVoicemailDialog: false,
                isInternalTransfer: false,
                isMuted: false,
                isOutbound: false,
                isRecordingPaused: false,
                isRunningAction: false,
                isSupervisorLoading: false,
                numberToCall: null,
                makingCall: false,
                onHold: false,
                otherLegRecordEnabled: false,
                snackbar: {
                    color: null,
                    show: false,
                    text: null,
                    timeout: 2500,
                },
                status: null,
                telnyxCall: null,
                transferDestination: null,
                transferDestinationID: null,
                transferDialog: false,
                transferLocation: null,
                transferToExtension: null,
                transferToNumber: null,
                transferType: null,
                webRtcParticipant: null,
                webRtcSession: null,
                whisperAudio: null,
                whisperMode: null,
                whisperValue: null,
            }
        },
        methods: {
            buildAvailableDialPhoneNumbers() {

                // Reinit
                this.availableDialPhoneNumbers = [];

                // Verify
                if (!this.communicationManager || !(this.communicationManager?.customer_phone_numbers?.length > 0)) {
                    return;
                }

                // Loop through phone numbers and build array
                for (let i = 0; i < this.communicationManager.customer_phone_numbers.length; i++) {

                    // Init
                    const customerPN = this.communicationManager.customer_phone_numbers[i];
                    if (!customerPN || !(customerPN.customer_phone_number_id > 0)) {
                        continue;
                    }

                    // Push onto array
                    this.availableDialPhoneNumbers.push(customerPN);
                }

                this.continueSaveAndDialNextIfApplicable();
            },
            clearComplianceSnackbarTimeout() {
                if (this.complianceSnackbarTimeoutId !== null) {
                    clearTimeout(this.complianceSnackbarTimeoutId);
                    this.complianceSnackbarTimeoutId = null;
                }
            },
            closeDialPad() {
                this.dialPadDialog = false;
            },
            closeInstantVoicemail(snackbarColor, snackbarText) {
                this.instantVoicemailDialog = false;
                this.showSnackbar(snackbarColor, snackbarText);

                // If there is a valid snackbarColor, then that means the current user left an instant voicemail and we need to disconnect them
                if (snackbarColor?.length > 0) {
                    this.endCall();
                }
            },
            createAgentForOnCall() {

                // VE-10377: do not re-mint Outgoing/Incoming for a call that already ended.
                if (this.isDisconnectedCall()) {
                    return;
                }

                // Init
                const options = {
                    call_id: (this.call?.id || 0),
                    campaign_customer_id: (this.currentCampaignCustomer?.campaign_customer_id || 0),
                    campaign_id: (this.currentCampaignCustomer?.campaign_id || 0),
                    conference_id: (this.call?.conference_id || 0),
                    immediately_move_to_status: null,
                    noticeable_id: (this.currentCampaignCustomer?.campaign_customer_id || 0),
                    noticeable_type: "campaign_customer",
                    organization_id: (this.currentCampaignCustomer?.organization_id || 0),
                    status_name: (this.isOutbound === true ? "Outgoing Call" : "Incoming Call"),
                    scheduled_communication_id: (this.pendingSavedPlaceCall?.scheduled_communication_id || 0),
                }

                this.createAgent(options);
            },
            createAgentForWrapUp(endedCall) {

                if (this.componentDestroyed) {
                    return;
                }

                // VE-10380: attribute wrap up to the call that ended, not whatever call is current now.
                const wrapUpCall = endedCall?.id > 0 ? endedCall : this.call;

                // VE-10380: save-and-next get-next can assign the next customer before disconnect — skip stale wrap-up.
                if (this.shouldSkipWrapUpForGetNextAdvance(wrapUpCall?.id || 0)) {
                    return;
                }

                // Init
                const options = {
                    call_id: (wrapUpCall?.id || 0),
                    campaign_customer_id: (this.currentCampaignCustomer?.campaign_customer_id || 0),
                    campaign_id: (this.currentCampaignCustomer?.campaign_id || 0),
                    conference_id: (wrapUpCall?.conference_id || 0),
                    immediately_move_to_status: null,
                    noticeable_id: (this.currentCampaignCustomer?.campaign_customer_id || 0),
                    noticeable_type: "campaign_customer",
                    organization_id: (this.currentCampaignCustomer?.organization_id || 0),
                    status_name: (this.isOutbound === true ? OUTBOUND_WRAP_UP : INBOUND_WRAP_UP),
                    scheduled_communication_id: (this.pendingSavedPlaceCall?.scheduled_communication_id || 0),
                }

                this.createAgent(options);
            },
            createConferenceEvent(error) {

                console.debug("inside create conference event: ", error)

                const options = {
                    error_message: error,
                    call_id: 0, // if there is a device error before we have a call id, we'll still ctx log it on BE
                }

                if (this.call?.id > 0) {
                    options.call_id = this.call.id
                }

                console.debug(options)

                CreateConferenceEvent(options).then((response) => {
                    console.debug(response)
                });
            },
            createSession() {
                if (!this.validIncomingPhoneNumber) {
                    return;
                }

                const options = {
                    incoming_phone_number_id: this.incomingPhoneNumber.incoming_phone_number_id,
                }

                CreateWebRtcParticipant(options).then((response) => {
                    if (response?.Data?.web_rtc_participant?.id > 0) {

                        // Set web rtc objects
                        this.webRtcParticipant = response?.Data?.web_rtc_participant;
                        this.webRtcSession = response?.Data?.web_rtc_session;
                        this.agentToken = response?.Data?.web_rtc_participant?.token;

                    }
                });
            },
            async connectDeviceToCall() {

                // VE-10377: after an intentional hang-up, do not reconnect to the dead call.
                if (this.isDisconnectedCall()) {
                    return;
                }

                if (!this.call || !!this.connection) {
                    return;
                }

                if (this.call.id <= 0) {
                    return;
                }

                // Verify device is ready
                if (!(this.status === "ready" && !!this.device)) {
                    return;
                }

                // Verify outbound call didn't error
                if (this.callFailed) {
                    console.debug("call failed")
                    return;
                }

                // Connect device
                this.connectAttempt = true;
                console.debug("connect device to call")

                // VE-10380: snapshot the call this connection owns so a lagging teardown attributes wrap up correctly.
                this.connectedCall = { ...this.call };

                this.connection = this.device.newCall({
                    customHeaders: [ { name: 'X-VolieCallId', value: this.call.id.toString(), },
                        { name: 'volieBarge', value: this.isBarge, },
                        { name: 'volieListen', value: this.isListen, },
                    ],
                    destinationNumber: this.incomingPhoneNumber.phone_number,
                });


                // Set device status to busy
                this.status = "busy";

                // Set back to false since we are no longer setting up phone call
                this.initializingPhoneCall = false;

                // Create agent
                this.createAgentForOnCall();

                // // Connect device
                // this.connection = this.device?.connect().then(async () => {
                //     console.debug("connect device to call")
                //     // Publish the browser's microphone
                //     this.device.enableMicrophone();
                //     // console.debug("browser mic is streaming");
                //     // Set device status to busy
                //     this.status = "busy";
                //     // Set back to false since we are no longer setting up phone call
                //     this.initializingPhoneCall = false;
                //     // Create agent
                //     this.createAgentForOnCall();
                // });
            },
            continueForceStartNextDialIfApplicable() {
                if (this.forceStartNextDial !== true || this.isBlockedFromDialOrReconnectDuringWrapUp()) {
                    return false;
                }

                let started = false;
                if (this.validVoiceMailRecording) {
                    started = this.startNextDial(null, this.voiceMailRecording?.voice_mail_recording_id) === true;
                } else if (this.validPendingSavedPlaceCall) {
                    started = this.startNextDial(null, null, this.pendingSavedPlaceCall.scheduled_communication_id) === true;
                } else if (this.forceValidatedOutboundNumber) {
                    started = this.startNextDial(null, null, null, this.forceValidatedOutboundNumber) === true;
                }

                if (started && typeof this.clearDialIntent === "function") {
                    this.clearDialIntent();
                }
                return started;
            },
            continueSaveAndDialNextIfApplicable() {

                // Action must be continue and start
                if (this.saveAndNextAction !== "continue_and_start") {
                    return false;
                }

                // VE-10377: wrap-up must not auto-dial (fail-safe: do not dial).
                if (this.isBlockedFromDialOrReconnectDuringWrapUp()) {
                    return false;
                }

                // VE-8387: auto-served missed calls must show only — Dial / Return Call is explicit.
                if (this.missedCallFromCallScreen) {
                    if (typeof this.clearDialIntent === "function") {
                        this.clearDialIntent();
                    }
                    return false;
                }

                // Must have phone numbers
                if (!(this.availableDialPhoneNumbers?.length > 0)) {
                    return false;
                }

                // Call must be null
                if (this.call !== null) {
                    return false;
                }

                // Device must be ready
                if (!this.device || this.status !== "ready") {
                    return false;
                }

                // One-shot only after dial actually starts (VE-8387) — keep intent if startNextDial no-ops.
                const started = this.startNextDial();
                if (started && typeof this.clearDialIntent === "function") {
                    this.clearDialIntent();
                }
                return started === true;
            },
            handleVinLoginDecisionIfNeeded() {
                if (this.vinLoginDecisionPending !== true) {
                    return false;
                }

                this.onVinLoginDecisionRequired?.();
                return true;
            },
            deviceErrorHandler(e) {
                this.status = "error";
                console.error('telnyx error:', e);

                // Make a post to volie conference status event to log telnyx device error
                this.createConferenceEvent(e);

                this.device.disconnect();
                this.detachListeners(this.device);
            },
            stringifyNotification(obj){
                let cache = [];
                const str = JSON.stringify(obj, function(key, value) {
                    if (typeof value === "object" && value !== null) {
                    if (cache.indexOf(value) !== -1) {
                        // Circular reference found, discard key
                        return;
                    }
                    // Store value in our collection
                    cache.push(value);
                    }
                    return value;
                });
                cache = null; // reset the cache
                return str;
            },
            deviceNotificationEventLog(notification) {
                // send this string to the browser along with device type
                const notificationStr = this.stringifyNotification(notification)

                console.debug(notification)

                const options = {
                    call_id: 0,
                    device_provider_type: "telnyx",
                    notification: notificationStr,
                    call_state: notification.call.state,
                    device_call_sid: notification.call.id,
                }

                if (this.call?.id > 0) {
                    options.call_id = this.call.id;
                }

                CreateDeviceNotificationEvent(options).then((response) => {
                    if (response.Error !== null) {
                        console.error('volieInternal Event saving error: ', response.Error)
                    }
                })
            },
            deviceNotificationHandler(notification) {
                if (this.call?.id > 0) {
                    notification.volie_call_id = this.call.id
                }

                // TODO: remove post debugging fix
                console.debug("Device Notification Handler: ", notification)

                // Error handle
                if (!notification) {
                    return;
                }

                // Init
                this.telnyxCall = notification?.call;
                if (!this.validTelnyxCall) {
                    return;
                }

                this.ensureOverflowHidden();

                // Check the type of the notification
                switch(notification?.type) {
                case "callUpdate":
                    // TODO: remove post debugging fix
                    console.debug("TelnyxState", this.telnyxCall?.state)
                    switch (this.telnyxCall?.state) {
                        case 'new':
                            console.debug('volieInternal: new call')
                            // Play audio
                            break;
                        case 'requesting':
                            console.debug('volieInternal: requesting call')
                            // Stop audio
                            break;
                        case 'trying':
                            console.debug('volieInternal: trying call')
                            // Stop audio
                            break;
                        case 'early':
                            console.debug('volieInternal: early call')
                            // Stop audio
                            break;
                        case 'active':
                            console.debug('volieInternal: active call')
                            if (this.isSupervisor) {
                                this.isSupervisorLoading = false;
                            }
                            break;
                        case 'hangup':
                            console.debug('volieInternal: hangup call')
                            this.telnyxCall = null;
                            // Stop audio
                            this.disconnectDevice();
                            // this.status = "ready";
                            break;
                        case 'purge':
                            console.debug('volieInternal: purge call')
                            // Stop audio
                            break;
                        case 'destroy':
                            console.debug('volieInternal: DESTROY call')
                            // Stop audio
                            this.telnyxCall = null;
                            this.disconnectDevice();
                            break;
                        case 'ringing':
                            console.debug('volieInternal: ringing call')
                            this.telnyxCall.answer();
                            break;
                        case 'answering':
                            console.debug('volieInternal: answering call')
                            break;
                        case 'recovering':
                            console.debug('volieInternal: recovering call')
                            break;
                        default:
                            break;
                    }
                    break;
                case "userMediaError":
                    console.error('Permission denied or invalid audio/video params on `getUserMedia`');
                    break;
                }

                if (import.meta.env.VITE_APP_LOG_DEVICE_NOTIFICATION_EVENTS === "1") {
                    this.deviceNotificationEventLog(notification)
                }
            },
            deviceReadyHandler() {
                // this is so we don't reset the status to busy on an internal transfer
                if (this.isInternalTransfer) {
                    this.status = "busy";
                } else {
                    this.status = "ready"
                }
                console.debug("device is ready");
            },
            deviceSocketCloseHandler(e) {
                if(this.device) {
                    this.device.disconnect();
                    this.detachListeners(this.device);
                    this.status = "ready";
                }
            },
            detachListeners(client){
                if(client) {
                    client.off('telnyx.error');
                    client.off('telnyx.ready');
                    client.off('telnyx.notification');
                    client.off('telnyx.socket.close');
                }
            },
            destroySounds() {
                this.pauseAudio("audioPhoneDeviceConnect");
                this.pauseAudio("audioPhoneDeviceDisconnect");
                this.pauseAudio("audioPhoneDeviceRinging");
                this.pauseWhisperAudio();
            },
            async disconnectDevice() {

                // Only need to disconnect once
                if (this.disconnectedPhoneCall) {
                    return;
                }

                // Only need to disconnect once
                if (this.componentDestroyed) {
                    return;
                }

                // Stop audio(s) (in case they are still going due to hanging up while ringing)
                this.destroySounds();

                // Unpublish browser mic
                await this.muteUnmuteCall();

                // Disconnect device
                await this.device?.disconnect();

                // Set to true so we render next buttons
                this.disconnectedPhoneCall = true;

                // Scope the dial/reconnect refusal to the call that actually ended
                this.disconnectedCallId = this.connectedCall?.id || this.call?.id || 0;

                this.complianceWarnings = [];

                // Set device status back to ready
                this.status = "ready";

                // Set back to null since call is over
                this.connection = null;

                // Create agent
                this.createAgentForWrapUp(this.connectedCall);

                // Consume the snapshot so a repeat teardown falls back to the current call
                this.connectedCall = null;

                // Play disconnect audio
                await this.playAudio("audioPhoneDeviceDisconnect");
            },
            endCall() {

                this.telnyxCall?.hangup();
                 // Only run once
                 if (this.ranEndCall) {
                    return;
                }

                // Mark as ran
                this.ranEndCall = true;

                // // TEST -- DO NOT USE --
                // this.createConferenceEvent("testing disconnect error")

                // Disconnect browser device
                this.disconnectDevice(); // manually disconnect device

                // Handle agent leg disconnect
                this.handleAgentCallDisconnect();
            },
            ensureOverflowHidden() {

                // HACK: HERE
                const htmlTag = document.getElementsByTagName('html')[0];
                window.scrollTo(0, 0);

                if (!!htmlTag) {
                    // remove tags
                    htmlTag.classList.remove('overflow-y-hidden');
                    htmlTag.classList.remove('overflow-y-scroll');
                    htmlTag.classList.add('overflow-y-hidden');

                }

                return;
            },
            async executeWhisper() {

                // Verify
                if (!this.validWhisper) {
                    return;
                }

                // Switch over mode
                switch(this.whisperMode) {
                case "play":

                    // Play audio file
                    await this.playWhisperAudio();
                    break;

                case "say":

                    // Speak
                    await this.speakSentence(this.whisperValue);
                    break;
                }
            },
            exitTransferDialog() {
                this.transferBridgeCalls = false;
                this.transferToExtension = null;
                this.transferType = null;
                this.transferDialog = false;
            },
            handleAgentCallDisconnect() {

                if (!this.validCall) {
                    return;
                }

                const options = {
                    isBarge: this.isBarge,
                    isListen: this.isListen,
                    isCoaching: this.isCoach,
                }

                // Place customer leg on hold
                HandleAgentCallDisconnect(this.call.id, options).then((response) => {
                    if (response?.Data?.Ok === true) {
                        // Call ended successfully
                    }
                });
            },
            holdCall() {
                if (this.onHold || !this.validCall || this.isRunningAction) {
                    return;
                }

                // Set to true so the user cannot submit multiple requests at once
                this.isRunningAction = true;

                // Place customer leg on hold
                HoldCall(this.call.id).then((response) => {
                    if (response?.Data?.Ok === true) {
                        this.onHold = true;

                        // Agent leg also gets put on mute
                        this.muteCall();
                    }

                    this.isRunningAction = false;
                });
            },
            holdUnholdCall() {
                if (!this.validTelnyxCall) {
                    return;
                }
                return this.onHold ? this.unholdCall() : this.holdCall();

                // if (this.onHold) {
                //     this.telnyxCall.unhold().then(() => {
                //         this.onHold = false;
                //     });
                // } else {
                //     this.telnyxCall.hold().then(() => {
                //         this.onHold = true;
                //     });
                // }
            },
            handleCreateOutboundCallResponse(data, error) {

                // Set call still if applicable - it is possible to have a valid call record that errored
                if (data?.call?.id > 0) {
                    this.call = data.call;
                    this.conference = data.conference;
                    this.otherLegRecordEnabled = data.other_leg_record_enabled;
                    this.complianceWarnings = data?.compliance_warnings?.length > 0 ? data.compliance_warnings : [];
                }

                // Handle error if necessary
                if (this.callFailed) {
                    this.handleOutboundCallError(error);
                }
            },
            handleOutboundCallError(errorMessage) {

                // If it errored, we need to unfreeze the agent status push if necessary
                if (this.freezeAgentStatusPush) {
                    this.toggleFreezeAgentStatusPush();
                }

                // Render error for agent to see
                if (errorMessage?.length > 0) {
                    this.showSnackbar("error", errorMessage);
                }

                // Set back to false since we no longer are doing this
                this.initializingPhoneCall = false;

                // Move agent into wrap up
                this.createAgentForWrapUp(this.call);
            },
            initDevice() {

                // Already have a valid device, no need to init
                if (this.validDevice) {
                    return;
                }

                if (!this.agentToken) {
                    return;
                }

                // Init
                this.device = new TelnyxRTC({
                    login_token: this.agentToken,
                });

                // Setup
                this.setupDevice();
            },
            hangup() {
                if (this.validTelnyxCall) {
                    this.telnyxCall.hangup();
                    this.makingCall = false;
                }
            },
            isBlockedFromDialOrReconnectDuringWrapUp() {
                // Local disconnect covers the window before Wrap Up status is pushed.
                if (this.isDisconnectedCall()) {
                    return true;
                }
                return this.isWrapUpBlockingDial === true;
            },
            isDisconnectedCall() {
                // Only refuse the call that actually ended — a new call id must be allowed through.
                return this.disconnectedCallId > 0 && this.disconnectedCallId === (this.call?.id || 0);
            },
            loadWhisperAudio() {
                if (this.whisperMode === "play" && this.whisperValue?.length > 0) {
                    this.whisperAudio = new Audio(this.whisperValue);
                }
            },
            moveCallIntoWebRtcSession() {

                // Verify call
                if (!this.validCall) {
                    return;
                }

                // Create agent
                this.createAgentForOnCall();

                // Ensure forceWebRtcParticipant is present (because it should be an inbound call or agent to agent transfer, or barge/listen)
                if (!(this.forceWebRtcParticipant?.id > 0)) {
                    return;
                }

                let supervisorRole = ""
                if (this.isBarge) {
                    supervisorRole = "barge"
                } else if (this.isListen) {
                    supervisorRole = "listen"
                } else if (this.isCoach) {
                    supervisorRole = "coaching"
                }

                const options = {
                    supervisor_role: supervisorRole
                }

                // Create call and join conference
                CallJoinWebRtcSession(this.call.id, options).then((response) => {
                    if (response?.Data?.ok !== true) {
                        // todo - error handle
                    }
                });
            },
            muteCall() {
                if (this.isMuted || !this.validCall || this.isRunningAction) {
                    return;
                }


                this.telnyxCall.unmuteAudio()

                // Set muted
                this.isMuted = true;
                console.log("browser mic is no longer streaming");
                // Mute agent leg
                // MuteCall(this.call.id).then((response) => {
                //     if (response?.Data?.Ok === true) {
                //         this.isMuted = true;
                //     }

                //     this.isRunningAction = false;
                // });
            },
            muteConferenceLeg() {
                const options = {
                    call_id: this.call.id,
                    supervisor_call: true,
                }
                MuteConferenceLeg(this.call.conference_id, options).then((response) => {
                    if (response?.Data?.Ok === true) {
                        // Call ended successfully
                        this.isMuted = true;
                    } else {
                        this.showSnackbar("error", "Unable to mute conference leg");
                    }
                });
            },
            unMuteConferenceLeg() {
                const options = {
                    call_id: this.call.id,
                    supervisor_call: true,
                }
                UnMuteConferenceLeg(this.call.conference_id, options).then((response) => {
                    if (response?.Data?.Ok === true) {
                        // Call ended successfully
                        this.isMuted = false;
                    } else {
                        this.showSnackbar("error", "Unable to unmute conference leg");
                    }
                });
            },
            muteUnmuteCall() {
                if (!this.validTelnyxCall) {
                    return;
                }

                if (this.onHold == true) {
                    return;
                }

                // No need to run on a disconnected call
                if (this.componentDestroyed) {
                    return;
                }

                if (this.ranEndCall) {
                    return;
                }

                // check for barge, listen, or coach
                if (this.isSupervisor) {

                    if (this.isMuted) {
                        this.unMuteConferenceLeg();
                        this.isMuted = false;
                    } else {
                        this.muteConferenceLeg();
                        this.isMuted = true;
                    }

                    return;
                }
                if (this.isMuted) {
                    this.telnyxCall.unmuteAudio();
                    this.isMuted = false;
                } else {
                    this.telnyxCall.muteAudio();
                    this.isMuted = true;
                }


            },
            onCallEventNew(response) {

                // Verify data
                const callEvent = response?.Data;
                if (!callEvent || !(callEvent?.call_event_id > 0)) {
                    return;
                }

                switch (callEvent.leg) {
                    case "agent": // agent leg (could also be a manager on a barge or listen)
                        break;
                    case "agent transfer": // agent to agent transfer leg
                        break;
                    case "customer": // customer leg

                        // Switch over events
                        switch (callEvent.call_status) {
                        case "answered":
                            this.destroySounds();
                            break;
                        case "in-progress":
                            this.destroySounds();
                            break;
                        }

                        break;
                    case "transfer": // transfer leg
                        break;
                }
            },
            onConferenceUpdate(response) {

                // Verify data
                const conference = response?.Data;
                if (!conference || !(conference?.id > 0)) {
                    return;
                }

                // Verify conference matches conference on device
                if (!this.conference || !(conference.id === this.conference?.id)) {
                    return;
                }

                // Set updates
                this.conference.recording_id = conference.recording_id;
            },
            async runDeviceBusyFeedback() {

                // Play beeping to let user know browser mic is now live
                await this.playAudio("audioPhoneDeviceConnect");

                // Sleep so whisper does not happen right after audio
                await this.sleep(1000);

                // Say or play whisper
                await this.executeWhisper();

                // OUTBOUND ONLY, play ringing mp3 until device picks up new subscription (customer leg)
                // Need to ensure stream is not already established (in IVR cases it picks up instantly)
                if (this.isOutbound === true && !this.isStreamAvailable) {
                    this.playAudio("audioPhoneDeviceRinging");
                }
            },
            setupDevice() {

                // Declare handlers
                this.device.on('telnyx.ready', this.deviceReadyHandler)
                this.device.on('telnyx.notification', this.deviceNotificationHandler)
                this.device.on('telnyx.socket.close', this.deviceSocketCloseHandler)
                this.device.on('telnyx.error', this.deviceErrorHandler)
                this.device.on('telnyx.socket.error', this.deviceErrorHandler)

                // Set audio
                this.device.remoteElement = 'remoteMedia';

                // Turn device on
                this.device.enableMicrophone();
                this.device.connect();
            },
            sendDigit(digit, isTransfer) {

                // Verify digit
                if (!(digit?.length > 0) || !this.validTelnyxCall) {
                    return;
                }

                // Verify connection, device, call, and session ID
                if (!this.validConnection || !this.validDevice || !this.validCall || !this.renderPhoneControls) {
                    return;
                }

                const options = {
                    digit: digit,
                    is_transfer: isTransfer || false,
                }

                SendDTMF(this.call.id, options).then((response) => {
                    if (response?.Data?.Ok === true) {
                        // DTMF sent successfully
                    } else {
                        // DTMF failed to send
                        this.showSnackbar("error", "Unable to send digit");
                    }
                });

                // Switch over digit to play audio
                switch(digit) {
                case "0":
                    this.playAudio("audioPhoneDeviceDtmf0");
                    break;

                case "1":
                    this.playAudio("audioPhoneDeviceDtmf1");
                    break;

                case "2":
                    this.playAudio("audioPhoneDeviceDtmf2");
                    break;

                case "3":
                    this.playAudio("audioPhoneDeviceDtmf3");
                    break;

                case "4":
                    this.playAudio("audioPhoneDeviceDtmf4");
                    break;

                case "5":
                    this.playAudio("audioPhoneDeviceDtmf5");
                    break;

                case "6":
                    this.playAudio("audioPhoneDeviceDtmf6");
                    break;

                case "7":
                    this.playAudio("audioPhoneDeviceDtmf7");
                    break;

                case "8":
                    this.playAudio("audioPhoneDeviceDtmf8");
                    break;

                case "9":
                    this.playAudio("audioPhoneDeviceDtmf9");
                    break;

                case "#":
                    this.playAudio("audioPhoneDeviceDtmfHash");
                    break;

                case "*":
                    this.playAudio("audioPhoneDeviceDtmfStar");
                    break;

                }
            },
            showSnackbar(color, text) {
                if (color?.length > 0 && text?.length > 0) {
                    this.snackbar.color = color;
                    this.snackbar.text = text;
                    this.snackbar.show = true;
                }
            },
            sleep(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            },
            async speakSentence(text) {

                // Promise to wait for speech to finish
                await new Promise(function(resolve) {

                    // Verify text
                    if (!(text?.length > 0)) {
                        return;
                    }

                    // Init speech
                    const msg = new SpeechSynthesisUtterance(text);
                    if (!msg) {
                        return;
                    }

                    // Settings
                    msg.lang = "en-US";
                    msg.rate = 1;
                    msg.pitch = 1;
                    msg.volume = 1;

                    // Init voices
                    const voices = window.speechSynthesis.getVoices();

                    // If present here, then the agent is past the first call and so the voices have loaded by now
                    if (voices?.length > 0) {

                        // Find voice
                        msg.voice = voices.filter(function(voice) { return voice.name == 'Google US English'; })[0];

                        // Set on end
                        msg.onend = resolve;

                        // Speak
                        window.speechSynthesis.speak(msg);

                    } else {

                        // Wait for voices to load if they haven't loaded before
                        new Promise(resolve => window.speechSynthesis.onvoiceschanged = resolve).then(() => {

                            // Init voices
                            const voices = window.speechSynthesis.getVoices();
                            if (voices?.length > 0) {
                                msg.voice = voices.filter(function(voice) { return voice.name == 'Google US English'; })[0];
                            }

                            // Set on end
                            msg.onend = resolve;

                            // Speak
                            window.speechSynthesis.speak(msg);
                        });
                    }
                });
            },
            startNextDial(overrideCustomerPhoneNumberId, overrideReturnVoiceMailRecordingID, overrideScheduledCommunicationID, forceOutboundNumber) {
                if (this.handleVinLoginDecisionIfNeeded()) {
                    return false;
                }

                // VE-10377: wrap-up must not start another Outgoing Call (fail-safe: do not dial).
                if (this.isBlockedFromDialOrReconnectDuringWrapUp()) {
                    return false;
                }

                // Verify we have a valid cc or an overriding from number (missed call use case)
                if ((!this.validCurrentCampaignCustomer || (!this.nextAttemptableID && !overrideCustomerPhoneNumberId)) && !(overrideReturnVoiceMailRecordingID > 0) && !(overrideScheduledCommunicationID > 0)) {
                    return false;
                }

                // If we already have a valid call or are initializing, abort
                if (!!this.call || this.initializingPhoneCall === true) {
                    return false;
                }

                // Set
                this.initializingPhoneCall = true;
                this.isOutbound = true;
                this.complianceWarnings = [];

                const options = {
                    account_id: (this.currentCampaignCustomer.account_id || 0),
                    attempt_key: this.currentAgent?.attempt_key,
                    force_outbound_number: forceOutboundNumber,
                    force_outbound_campaign_id: this.currentCampaignCustomer?.campaign_id || 0,
                    campaign_customer_active_id: (this.currentCampaignCustomer.campaign_customer_active_id || 0),
                    incoming_phone_number_id: (this.incomingPhoneNumber?.incoming_phone_number_id || 0),
                    is_manual_call: this.isManualMode,
                    override_customer_phone_number_id: (overrideCustomerPhoneNumberId || 0),
                    override_return_voice_mail_recording_id: (overrideReturnVoiceMailRecordingID || 0),
                    web_rtc_participant_id: this.webRtcParticipant.id,
                    override_scheduled_communication_id: (overrideScheduledCommunicationID || 0),
                    // Only a returned voicemail names a source from the comm center, whether clicked or served by get next
                    source_id: (overrideReturnVoiceMailRecordingID || this.voiceMailRecording?.voice_mail_recording_id || 0),
                    source_type: ((overrideReturnVoiceMailRecordingID || this.voiceMailRecording?.voice_mail_recording_id) > 0 ? "voice_mail_recording" : ""),
                }

                console.debug("CreateOutboundCall")

                if (!this.freezeAgentStatusPush) {
                    this.toggleFreezeAgentStatusPush(); // set free to true so we don't push the agent into available after they've already started the process of dialing out
                }

                // Create outbound call
                CreateOutboundCall(options).then((response) => {
                    // Init
                    let needDelay = true;

                    // If error, need to mark call as fialed so we can start process of not getting the agent stuck
                    if (response?.Error?.length > 0) {
                        this.setCallFailed(true);
                        needDelay = true;
                    }

                    // If delay needed, add next tick
                    if (needDelay) {
                        Vue.nextTick(() => {
                            this.handleCreateOutboundCallResponse(response?.Data, response?.Error);
                        });
                    } else {
                        this.handleCreateOutboundCallResponse(response?.Data, response?.Error);
                    }
                });
                return true;
            },
            openDialPad() {
                this.dialPadDialog = true;
            },
            openInstantVoicemailDialog() {
                this.instantVoicemailDialog = true;
            },
            openTransferDialog(destination, location, type, destinationID, toNumber, toExtension) {
                this.transferDestination = destination;
                this.transferDestinationID = destinationID;
                this.transferLocation = location;
                this.transferToExtension = toExtension || null;
                this.transferToNumber = toNumber;
                this.transferType = type;
                this.transferDialog = true;
            },
            pauseRecording() {
                if (!this.validRecordingID || this.isRunningAction) {
                    return;
                }

                // Set to true so the user cannot submit multiple requests at once
                this.isRunningAction = true;

                // Pause recording
                PauseRecording(this.recordingID).then((response) => {
                    if (response?.Data?.ok === true) {
                        this.isRecordingPaused = true;
                        this.showSnackbar("green", "Successfully paused call recording");
                    }

                    this.isRunningAction = false;
                });
            },
            pauseResumeRecording() {
                if (!this.validRecordingID || this.isRunningAction) {
                    return;
                }

                return this.isRecordingPaused === true ? this.resumeRecording() : this.pauseRecording();
            },
            pauseWhisperAudio() {
                return !!this.whisperAudio ? this.whisperAudio.pause() : null;
            },
            pauseAudio(key) {
                return key?.length > 0 && !!this[key] ? this[key].pause() : null;
            },
            phoneAllowed(cpn) {

                // Verify
                if (!cpn || !(cpn.customer_phone_number_id > 0)) {
                    return false;
                }

                return (cpn.do_not_call === false && cpn.phone_number_do_not_call === false && cpn.has_account_or_organization_opt_out_phone === false && cpn.phone_number_is_litigator === false);
            },
            playAudio(key) {
                if (this.userDomInteraction === true && key?.length > 0 && !!this[key]) {

                    // Rewind current audio back to the start since this audio object is only loaded once
                    this[key].currentTime = 0;

                    // Play audio
                    this[key].play().catch(() => {});
                }
            },
            async playWhisperAudio() {

                // Init due to scope
                const whisperAudio = this.whisperAudio;
                const userDomInteraction = this.userDomInteraction;

                // Promise to wait for play to finish
                return await new Promise(function(resolve) {

                    // Ensure dom interaction and valid audio
                    if (userDomInteraction === true && !!whisperAudio) {
                        whisperAudio.onended = resolve;
                        whisperAudio.play().catch(() => resolve());
                    }
                });
            },
            resumeRecording() {
                if (!this.validRecordingID || this.isRunningAction) {
                    return;
                }

                // Set to true so the user cannot submit multiple requests at once
                this.isRunningAction = true;

                // Pause recording
                ResumeRecording(this.recordingID).then((response) => {
                    if (response?.Data?.ok === true) {
                        this.isRecordingPaused = false;
                        this.showSnackbar("green", "Successfully resumed call recording");
                    }

                    this.isRunningAction = false;
                });
            },
            toggleOnHold() {
                this.onHold = !this.onHold;
            },
            toggleIsMuted() {
                this.isMuted = !this.isMuted;
            },
            unholdCall() {
                if (!this.onHold || !this.validCall || this.isRunningAction) {
                    return;
                }

                // Set to true so the user cannot submit multiple requests at once
                this.isRunningAction = true;

                // Place customer leg on hold
                UnholdCall(this.call.id).then((response) => {
                    if (response?.Data?.Ok === true) {
                        this.onHold = false;

                        // Agent leg also gets taken off mute
                        this.unmuteCall();
                    }

                    this.isRunningAction = false;
                });
            },
            unmuteCall() {
                if (!this.isMuted || !this.validCall || this.isRunningAction) {
                    return;
                }

                this.telnyxCall.unmuteAudio();
                this.isMuted = false;

                // // Set to true so the user cannot submit multiple requests at once
                // this.isRunningAction = true;

                // // Unmute agent leg
                // UnmuteCall(this.call.id).then((response) => {
                //     if (response?.Data?.Ok === true) {
                //         this.isMuted = false;
                //     }

                //     this.isRunningAction = false;
                // });
            },

        },
        computed: {
            accountPhoneSaveNext() {
                return this.currentUser?.account?.phone_save_next;
            },
            accountPhoneSaveStop() {
                return this.currentUser?.account?.phone_save_stop;
            },
            allowedExternalBlindTransfersEnabled() {
                return this.currentUser?.account?.enabled_transfers?.includes("external_blind_transfer");
            },
            allowedExternalWarmTransfersEnabled() {
                return this.currentUser?.account?.enabled_transfers?.includes("external_warm_transfer");
            },
            allowedInternalBlindTransfersEnabled() {
                return this.currentUser?.account?.enabled_transfers?.includes("internal_blind_transfer");
            },
            callId() {
                return this.call?.id;
            },
            currentAgent() {
                return VolieState.currentAgent();
            },
            currentUser() {
                return VolieState.currentUser();
            },
            instantVoiceMailEnabled() {
                if (this.isSupervisor) {
                    return false;
                }
                return this.currentUser?.account?.instant_voice_mail_enabled === true && this.isOutbound;
            },
            isStartNextDialButtonDisabled() {
                if (this.isSupervisor || this.isLiveDashInboundCall) {
                    return true;
                }

                return this.status !== "ready" || this.call?.id > 0 || !this.validAvailableDialPhoneNumbers;
            },
            isSupervisor() {
                return this.isBarge || this.isListen || this.isCoach
            },
            holdBtnColor() {
                return this.onHold ? "var(--lt-red)" : "";
            },
            muteBtnColor() {
                return this.isMuted && !this.onHold ? "var(--lt-red)" : "";
            },
            nextAttemptableID() {
                return this.validCurrentCampaignCustomer && this.currentCampaignCustomer.next_attemptable_id > 0 && this.currentCampaignCustomer.next_attemptable_type === "customer_phone_number" ? this.currentCampaignCustomer.next_attemptable_id : null;
            },
            recordEnabled() {
                return this.validCall && (this.call?.record_enabled === true || this.otherLegRecordEnabled === true) && this.currentUser?.account?.recording_pause_enabled;
            },
            recordingID() {
                return this.conference?.id > 0 && this.conference?.recording_id > 0 ? this.conference?.recording_id : null;
            },
            renderManualMode() {
                return !this.validVoiceMailRecording && !this.validPausedVoiceMailRecording;
            },
            renderNextActions() {
                if (this.isSupervisor || this.isLiveDashInboundCall) {
                    return false;
                }

                return (this.status !== "busy" && this.disconnectedPhoneCall && this.call?.id > 0) || this.callFailed === true;
            },
            renderPhoneControls() {
                // return true;
                return !this.initializingPhoneCall && this.status === "busy" && this.call?.id > 0;
            },
            renderSaveContinueButton() {
                return this.isManualMode || this.accountPhoneSaveNext === "continue" || this.validVoiceMailRecording || this.validPausedVoiceMailRecording;
            },
            renderSaveStopButton() {
                return !this.isManualMode && !this.validVoiceMailRecording && !this.validPausedVoiceMailRecording;
            },
            renderStartActions() {
                return (this.initializingPhoneCall || !this.call) && !this.callFailed;
            },
            saveAndStopAction() {
                return this.accountPhoneSaveStop === "continue" ? "continue" : "stop";
            },
            selectedDispositionHasSmsMessageFollowUp() {
                return this.selectedCampaignDisposition?.campaign_disposition_id > 0 && this.selectedCampaignDisposition?.has_sms_message_follow_up === true;
            },
            showTransferMenu() {
                return this.allowedInternalBlindTransfersEnabled || this.allowedExternalBlindTransfersEnabled || this.allowedExternalWarmTransfersEnabled;
            },
            userDomInteraction() {
                return VolieState.userDomInteraction();
            },
            validAvailableDialPhoneNumbers() {
                return this.availableDialPhoneNumbers?.length > 0;
            },
            validCall() {
                return this.call?.id > 0;
            },
            validConnection() {
                return !!this.connection;
            },
            validCurrentCampaignCustomer() {
                return this.currentCampaignCustomer?.campaign_customer_active_id > 0;
            },
            validDevice() {
                return !!this.device;
            },
            validIncomingPhoneNumber() {
                return this.incomingPhoneNumber?.incoming_phone_number_id > 0;
            },
            validNumberToCall() {
                return this.numberToCall?.length === 10;
            },
            validPausedVoiceMailRecording() {
                return this.isPausedVoiceMailRecording === true;
            },
            validRecordingID() {
                return this.recordingID > 0;
            },
            validTelnyxCall() {
                return this.telnyxCall?.state?.length > 0;
            },
            validVoiceMailRecording() {
                return this.voiceMailRecording?.voice_mail_recording_id > 0;
            },
            validWebRtcParticipant() {
                return this.webRtcParticipant?.id > 0 && this.webRtcParticipant?.token?.length > 0 && this.validWebRtcSession && this.webRtcParticipant?.web_rtc_session_id === this.webRtcSession?.id;
            },
            validWebRtcSession() {
                return this.webRtcSession?.id > 0
            },
            validWhisper() {
                return (this.whisperMode === "say" || this.whisperMode === "play") && this.whisperValue?.length > 0;
            },
            validPendingSavedPlaceCall() {
                return this.pendingSavedPlaceCall?.scheduled_communication_id > 0;
            },
        },
        components: {
            DialPad,
            InstantVoicemailDialog,
            ManualMode,
            TransferDialog,
        },
        props: {
            audioPhoneDeviceConnect: HTMLAudioElement,
            audioPhoneDeviceDtmf0: HTMLAudioElement,
            audioPhoneDeviceDtmf1: HTMLAudioElement,
            audioPhoneDeviceDtmf2: HTMLAudioElement,
            audioPhoneDeviceDtmf3: HTMLAudioElement,
            audioPhoneDeviceDtmf4: HTMLAudioElement,
            audioPhoneDeviceDtmf5: HTMLAudioElement,
            audioPhoneDeviceDtmf6: HTMLAudioElement,
            audioPhoneDeviceDtmf7: HTMLAudioElement,
            audioPhoneDeviceDtmf8: HTMLAudioElement,
            audioPhoneDeviceDtmf9: HTMLAudioElement,
            audioPhoneDeviceDtmfHash: HTMLAudioElement,
            audioPhoneDeviceDtmfStar: HTMLAudioElement,
            audioPhoneDeviceDisconnect: HTMLAudioElement,
            audioPhoneDeviceRinging: HTMLAudioElement,
            callFailed: Boolean,
            communicationManager: Object,
            completeAttemptForInternalTransfer: Function,
            createAgent: Function,
            currentCampaignCustomer: Object,
            enterManualMode: Function,
            exitManualMode: Function,
            forceCall: Object,
            forceConference: Object,
            forceEndCall: Boolean,
            forceStartNextDial: Boolean,
            forceTransferDialog: Object,
            forceWebRtcParticipant: Object,
            forceWebRtcSession: Object,
            hasLoggedInQueues: Boolean,
            onVinLoginDecisionRequired: Function,
            incomingPhoneNumber: Object,
            isBarge: Boolean,
            isCoach: Boolean,
            isListen: Boolean,
            isLiveDashInboundCall: Boolean,
            isManualMode: Boolean,
            isOkayToSaveAndNext: Boolean,
            isPausedVoiceMailRecording: Boolean,
            isWrapUpBlockingDial: Boolean,
            missedCallFromCallScreen: Boolean,
            organizationUsers: Array,
            pendingSavedPlaceCall: Object,
            removeForceTransferDialog: Function,
            retryDialIntentToken: Number,
            saveAndNextAction: String,
            clearDialIntent: Function,
            selectedCampaignDisposition: Object,
            setCall: Function,
            setCallFailed: Function,
            setOnCall: Function,
            shouldSkipWrapUpForGetNextAdvance: Function,
            startSaveAndNext: Function,
            voiceMailRecording: Object,
            toggleFreezeAgentStatusPush: Function,
            freezeAgentStatusPush: Boolean,
            forceValidatedOutboundNumber: String,
            vinLoginDecisionPending: Boolean,
        },
        watch: {
            complianceWarnings(warnings) {
                this.clearComplianceSnackbarTimeout();
                this.complianceSnackbarShow = warnings.length > 0;
                if (warnings.length > 0) {
                    this.complianceSnackbarTimeoutId = setTimeout(() => {
                        this.complianceSnackbarTimeoutId = null;
                        this.complianceSnackbarShow = false;
                    }, 10000);
                }
            },
            agentToken: {
                handler() {
                    this.initDevice();
                },
            },
            call: {
                deep: true,
                handler() {
                    this.connectDeviceToCall();
                    this.setCall(this.call);
                },
            },
            communicationManager() {
                this.buildAvailableDialPhoneNumbers();
            },
            "communicationManager.customer_phone_numbers": {
                deep: true,
                handler() {
                    this.buildAvailableDialPhoneNumbers();
                },
            },
            forceCall: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.forceCall?.id > 0 && !this.call) {
                        this.call = { ...this.forceCall };
                    }

                    if (this.isSupervisor) {
                        this.isSupervisorLoading = true;
                        if (this.call.direction === "outbound") {
                            this.isOutbound = true;
                        }

                        if (this.isListen) {
                            this.isMuted = true;
                        }
                    }
                },
            },
            forceConference: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.forceConference?.id > 0 && !this.conference) {
                        this.conference = { ...this.forceConference };
                    }
                },
            },
            forceEndCall: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.forceEndCall === true) {
                        this.endCall();
                    }
                },
            },
            // forceStartNextDial: {
            //     deep: true,
            //     immediate: true,
            //     handler() {
            //         if (this.forceStartNextDial === true) {

            //             // Use case #1 - return missed call
            //             if (this.validVoiceMailRecording) {
            //                 this.startNextDial(null, this.voiceMailRecording?.voice_mail_recording_id);

            //             // User case #2 - saved place in line call
            //             } else if (this.validPendingSavedPlaceCall) {

            //                 // wait a moment before starting next dial
            //                 setTimeout(() => {
            //                     this.startNextDial(null, null, this.pendingSavedPlaceCall.scheduled_communication_id)
            //                 }, 1000);

            //             }
            //         }
            //     },
            // },
            forceTransferDialog: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.forceTransferDialog?.destination?.length > 0 && !this.transferDialog) {
                        this.openTransferDialog(
                            this.forceTransferDialog.destination,
                            this.forceTransferDialog.location,
                            this.forceTransferDialog.type,
                            this.forceTransferDialog.destinationId,
                            this.forceTransferDialog.toNumber,
                            this.forceTransferDialog.toExtension,
                        );
                        this.removeForceTransferDialog();
                    }
                },
            },
            forceWebRtcParticipant: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.forceWebRtcParticipant?.id > 0 && !this.webRtcParticipant && this.forceWebRtcSession?.id > 0 && !this.webRtcSession) {

                        // Set web rtc
                        this.webRtcSession = { ...this.forceWebRtcSession };
                        this.webRtcParticipant = { ...this.forceWebRtcParticipant };
                        this.agentToken = this.webRtcParticipant?.token;
                        this.isInternalTransfer = true;
                        // this.initDevice();
                        // Set device status to ready
                        this.connection = this.forceWebRtcParticipant;
                    }
                },
            },
            // Disconnecting instance stays blocked while this.call is still the ended call; held dial
            // intent is redeemed by the device remounted after forceDestroy (get-next advance). Parent bumps
            // retryDialIntentToken only for dial-safe statuses after leaving wrap-up (VE-10377).
            retryDialIntentToken: {
                immediate: true,
                handler(token) {
                    if (!(token > 0)) {
                        return;
                    }
                    this.continueForceStartNextDialIfApplicable();
                    this.continueSaveAndDialNextIfApplicable();
                },
            },
            renderPhoneControls() {
                this.setOnCall(this.renderPhoneControls);

                // If we are no longer rendering the phone controls (no longer on call, close dialogs if applicable)
                if (!this.renderPhoneControls) {

                    // Dial pad
                    if (this.dialPadDialog) {
                        this.closeDialPad();
                    }

                    // Instant VM
                    if (this.instantVoicemailDialog) {
                        this.closeInstantVoicemail();
                    }

                    // Transfer
                    if (this.transferDialog) {
                        this.exitTransferDialog();
                    }
                }
            },
            status() {
                switch(this.status) {
                case "busy":

                    // Join customer leg to web rtc session if necessary: when inbound/agent to agent transfer, run feedback
                    if (this.forceWebRtcParticipant?.id > 0 ) {
                        this.moveCallIntoWebRtcSession();

                        // Note - we only want to run feedback for inbound calls => outbound is handled inside bridge sip connector
                        this.runDeviceBusyFeedback();
                    }

                    break;
                case "ready":
                    this.continueForceStartNextDialIfApplicable();
                    this.continueSaveAndDialNextIfApplicable();
                    break;
                }
            },
        },
        beforeDestroy () {
        },
        destroyed() {
            if (this.saveAndNextAction === "continue_and_start" || this.forceStartNextDial === true) {
                console.debug("device destroyed holding dial intent — retry depends on the remounted device");
            }

            this.clearComplianceSnackbarTimeout();

            // Stop playing all sounds
            this.destroySounds();
            this.componentDestroyed = true;

            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "callEventNew" }}, this.onCallEventNew);
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "conferenceUpdate" }}, this.onConferenceUpdate);

            this.device?.disconnect()
        },
        created() {
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "callEventNew" }}, this.onCallEventNew);
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "conferenceUpdate" }}, this.onConferenceUpdate);

            // Outbound call path should create a new session - inbound call's get their session created via the answer endpoint
            if (!this.validCall) {
                this.createSession();
            }
        },
    });
</script>

<style lang="scss" scoped>
    #app {
        .padding-xs {
            padding: 6px 0 6px 0;
        }

        .btn-margin-xs {
            margin: 4px 4px 4px 4px !important;
        }
    }
</style>
